import axios from 'axios';

const hostname = window.location.hostname;

const environment = {
  local: {
    api: process.env.REACT_APP_URL_SCHEDULING_LOCAL as string,
    apiGeneral: process.env.REACT_APP_URL_BASE_LOCAL as string,
    apiRouting: process.env.REACT_APP_URL_ROUTING_LOCAL as string,
    apiTracking: process.env.REACT_APP_URL_TRACKING_LOCAL as string,
    apiHub: process.env.REACT_APP_URL_HUB_LOCAL as string,
  },
  production: {    
    api: process.env.REACT_APP_URL_SCHEDULING as string,
    apiGeneral: process.env.REACT_APP_URL_BASE as string,
    apiRouting: process.env.REACT_APP_URL_ROUTING as string,
    apiTracking: process.env.REACT_APP_URL_TRACKING as string,
    apiHub: process.env.REACT_APP_URL_HUB as string,
  },
  homologacao: {
    api: process.env.REACT_APP_URL_SCHEDULING_HML as string,
    apiGeneral: process.env.REACT_APP_URL_BASE_HML as string,
    apiRouting: process.env.REACT_APP_URL_ROUTING_HML as string,
    apiTracking: process.env.REACT_APP_URL_TRACKING_HML as string,
    apiHub: process.env.REACT_APP_URL_HUB as string,
  },
};

const getEnvironment = () => {
  if (hostname === 'localhost') {
    return environment.local;
  }

  if (hostname === 'totem.kemira.webcol.systems') {
    return environment.production;
  }

  if (hostname === 'hml-totem.kemira.webcol.systems') {
    return environment.homologacao;
  }

  return environment.homologacao;
};

export const baseURL = getEnvironment();

export const dashboardUrl = process.env.REACT_APP_URL_DASHBOARD as string;

export const apiDashboard = axios.create({
  baseURL: dashboardUrl,
  headers: {},
  withCredentials: true,
});

export const apiGeneral = axios.create({
  baseURL: baseURL.apiGeneral,
  headers: {},
  //   withCredentials: true,
});

export const api = axios.create({
  baseURL: baseURL.api,
});

export const apiRouting = axios.create({
  baseURL: baseURL.apiRouting,
});

export const apiHub = axios.create({
  baseURL: baseURL.apiHub,
});

export const apiTracking = axios.create({
  baseURL: baseURL.apiTracking,
});

export const apiTecnospeed = axios.create({
  baseURL: process.env.REACT_APP_URL_TECNOSPEED as string,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Basic ${process.env.REACT_APP_AUTH_TECNOSPEED ?? ''}`,
  },
});

export const queryBuilder = (payload: Record<string, any>): string => {
  const validObject: Record<string, any> = {};

  for (const [param, value] of Object.entries(payload)) {
    if (value) Object.assign(validObject, { [param]: value });
  }

  const searchParams = new URLSearchParams(validObject).toString();
  return searchParams;
};

export const formDataBuilder = (payload: Record<string, any>): FormData => {
  const formData = new FormData();

  for (const [param, value] of Object.entries(payload)) {
    if (value instanceof File) {
      formData.append(param, value, value.name);
    } else if (value) {
      formData.append(param, value);
    }
  }

  return formData;
};

export const handleApiError = (error: any): Error => {
  return new Error(error?.response?.data?.error?.message || error?.message);
};
